import { View } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import { useTranslation } from 'react-i18next'
import AsyncStorage from '@react-native-async-storage/async-storage'
import SignatureFormView from '../SignatureFormView'

function W4preview({ navigation, route }: any) {
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    essUserOnBoardingFormKey,
    filingStatus,
    exemptFromFederalTax,
    higherWithholdingRate,
    munderAge,
    motherDependents,
    dependents,
    otherIncome,
    deductions,
    extraWithholdingPerPay,
    completeOnline,
    values,
    essUserOnBoardingKey
  } = params
  const { t } = useTranslation()
  const personalstore = usePersonalStore()
  const { postW4Data, loading } = useFormsStore()
  const intializestore = useInitializeStore()

  const getLanguage = async () => {
    try {
      const language = (await AsyncStorage.getItem('selectedLanguage')) || 'ENG'
      if (language === 'SPA') {
        return 'Spanish'
      } else {
        return 'English'
      }
    } catch (error) {
      console.error('Error retrieving selected language:', error)
      return 'English'
    }
  }
  const handlesubmit = async (signatureDataURL: string) => {
    const selectedLanguage = await getLanguage()
    const data = {
      filingStatus: filingStatus,
      exemptFromFederalTax: exemptFromFederalTax,
      higherWithholdingRate: higherWithholdingRate,
      munderAge: Number(munderAge),
      motherDependents: Number(motherDependents),
      dependents: Number(dependents),
      otherIncome: Number(otherIncome),
      deductions: Number(deductions),
       extraWithholdingPerPay:extraWithholdingPerPay? Number(extraWithholdingPerPay):null,
      essUserKey: intializestore?.initializeData?.userkey,
      entityId: personalstore?.personalData?.entityId,
      sign: signatureDataURL,
      FormKey: essUserOnBoardingFormKey,
      essObKey: userId,
      completeOnline: completeOnline,
      Language: selectedLanguage
    }

    const w4Data: any = await postW4Data(data)
    if (w4Data?.success) {
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: t(w4Data?.message),
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.replace('OnboardingForms')
        }
      })
    } else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: t(w4Data?.message),
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }

  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel={t('Forms')}
            navScreen="OnboardingForms"
            title={t('W-4 Information')}
          />
        </View>
      </View>
      <SignatureFormView
        essUserOnBoardingFormKey={essUserOnBoardingFormKey}
        essUserOnBoardingKey={essUserOnBoardingKey}
        isSubmitting={loading}
        onPrevious={() =>
          navigation.navigate('W4InformationForm', {
            essUserOnBoardingFormKey,
            essUserOnBoardingKey,
            values,
            mode: "online",

          })
        }
        onSubmit={handlesubmit}
        previousText={t('Previous')}
        submitText={t('Submit')}
      />
    </>

  )
}

export default W4preview
